// This is the model for a customer that we use around the site.
// It's roughly structured around parts of the Stripe Customer object
// but with parts we don't need omitted.
import type { NormalizedPaymentMethod } from './paymentMethod';

export interface StripeSubscriptionSummary {
  id: string;
  active: boolean;
  cancelAt: number | null;
  currentPeriodEnd: number | null;
  plan: {
    id: string;
    amount: number | null;
    amountFormatted: string;
    interval: string;
  } | null;
}

export interface NormalizedCustomer {
  id: string;
  email: string | null;
  uuid: string | undefined;
  subscription: StripeSubscriptionSummary | null;
  billingPortalSession: string;
}

export interface CustomerAttempts {
  search: {
    attempts: number;
    time: number;
  };
  direct: {
    attempts: number;
    time: number;
  };
}

export interface ExistingCustomerResult {
  customer: NormalizedCustomer | null;
  setupIntent: {
    clientSecret: string | null;
  };
  paymentMethod: NormalizedPaymentMethod | null;
  clientSecret?: string | null;
  attempts: CustomerAttempts;
}

const EMPTY_CUSTOMER: ExistingCustomerResult = {
  customer: null,
  setupIntent: {
    clientSecret: null,
  },
  paymentMethod: null,
  clientSecret: null,
  attempts: {
    search: {
      attempts: 0,
      time: 0,
    },
    direct: {
      attempts: 0,
      time: 0,
    },
  },
};

const hasActiveSubscription = (
  customer: NormalizedCustomer | null | undefined
): boolean => {
  return Boolean(customer?.subscription?.active);
};

export { EMPTY_CUSTOMER, hasActiveSubscription };
